import { React, PropTypes } from 'imports';
import TextInput from '../TextInput/TextInput';
import { FormattedResource } from '..';
import Spinner from '../Spinner/Spinner';
import { UTF8, Base64 } from 'utils/encoding';
import './ProxyFrame.less';
import { isAncestorOrSelf } from 'utils';


const RANDOM_VERSION = Math.random();
export function proxyURL(url) {
    return url && url.replace(/^(https?):\/\/(.*)$/g, (_, protocol, path) => (
        // TODO use backend assembly version
        // proxy modifies content and even if target resource is the same proxy itself and therefore content might have changed
        // backend proxy uses assembly version to preserve stuff in cache if assembly hasn't change
        // but here we can not use it
        // for now force reloading every time
        `/proxy/${protocol}?encodedURL=${Base64.getString(UTF8.getBytes(path)).replace(/\//g, '~').replace(/=/g, '_').replace(/\+/g, '-')}&version=${RANDOM_VERSION}`
    ));
}

export function deproxyURL(url) {
    return url && url.replace(/\/proxy\/(https?)\?encodedURL=(.*?)((\&|\?)version=[^&?]*)?$/g, (_, protocol, path) => (
        `${protocol}://${UTF8.getString(Base64.getBytes(path.replace(/~/g, '/').replace(/_/g, '=').replace(/-/g, '+')))}`
    ));
}



export default class ProxyFrame extends React.Component {
    static get propTypes() {
        return {
            src: PropTypes.string,
            className: PropTypes.string,
            navbar: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
            sidebar: PropTypes.node,
            overlay: PropTypes.node,
            scrollable: PropTypes.bool,

            onNavigate: PropTypes.func,
            onSuccess: PropTypes.func,
            onFail: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            className: '',
            navbar: true,
            scrollable: false
        }
    }

    _unloadTimeoutID = null

    state = {
        history: [''],
        currentIndex: 0,
        pending: false,
        editingURL: ''
    }

    componentDidMount() {
        window.addEventListener('message', this._onMessage);

        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.history.includes(nextProps.src)) {
            this._onURLSubmit(this, nextProps.src);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onMessage);

        if (this._unloadTimeoutID) {
            clearTimeout(this._unloadTimeoutID);
            this._unloadTimeoutID = null
        }
    }


    get window() {
        return this.refs.frame && this.refs.frame.contentWindow;
    }

    _addUnloadHandler() {
        const { frame } = this.refs;
        if (frame && frame.contentWindow && frame.contentWindow.onbeforeunload !== this._onBeforeUnload) {
            frame.contentWindow.onbeforeunload = this._onBeforeUnload;
            frame.contentWindow.onunload = () => {
                if (this._unloadTimeoutID) {
                    clearTimeout(this._unloadTimeoutID);
                }
                this._unloadTimeoutID = setTimeout(this._onAfterUnload, 0);
            }
            if (!this.props.scrollable) {
                frame.contentWindow.postMessage('4straction.addResizeListener', '*');
            }
            frame.contentWindow.postMessage('4straction.parentNavigationListener:' + (!!this.props.onParentNavigationRequest), '*');
        }
    }

    _removeUnloadHandler() {
        const { frame } = this.refs;
        if (frame && frame.contentWindow && frame.contentWindow.onbeforeunload === this._onBeforeUnload) {
            if (!this.props.scrollable) {
                this.refs.frame.style.height = '';
            }
            frame.contentWindow.onunload = null;
            frame.contentWindow.onbeforeunload = null;
        }
    }

    _onMessage = (event) => {
        switch (true) {
            case event.data.includes('4straction.initialDOMLoaded'):
                this._addUnloadHandler();
                break;

            case event.data.includes('4straction.resized'):
                if (!this.props.scrollable && this.refs.frame.contentWindow) {
                    this.refs.frame.style.height = '';
                    this.refs.frame.style.height = `${event.data.split(':')[1]}px`;
                }
                break;

            case event.data.includes('4straction.navigate:'):
                this.props.onParentNavigationRequest(this, event.data.replace('4straction.navigate:', '').replace(location.origin, ''));
                break;

            case event.data.includes('4straction.error:'):
                if (window.sendErrorReportToBackend) {
                    window.sendErrorReportToBackend(new Error(event.data.replace('4straction.error:', '')));
                }
                break;
        }
    }

    _onBeforeUnload = () => {
        if (this._unloadTimeoutID) {
            clearTimeout(this._unloadTimeoutID);
            this._unloadTimeoutID = null
        }

        if (!this.props.scrollable) {
            this.refs.frame.style.height = '';
        }
    }

    _onAfterUnload = () => {
        if (this._unloadTimeoutID) {
            clearTimeout(this._unloadTimeoutID);
            this._unloadTimeoutID = null
        }

        if (this.refs.frame && this.refs.frame.contentWindow) {
            this._onURLSubmit(this, deproxyURL(this.refs.frame.contentWindow.location.href.replace(window.location.origin, '')));
        }
    }

    _onNavigate = (history, index) => {
        let cancelled = false;
        if (this.props.onNavigate) {
            this.props.onNavigate(this, history[index], () => cancelled = true);
        }

        if (!cancelled) {
            this._removeUnloadHandler();

            this.setState({
                pending: true,
                history,
                currentIndex: index,
                editingURL: history[index]
            });
        }
        else {
            const src = this.refs.frame.src;
            this.refs.frame.src = '';
            this.refs.frame.src = src;
        }
    }

    _onLoad = () => {
        if (this._unloadTimeoutID) {
            this._onAfterUnload();
        }

        this.setState({ pending: false });

        if (this.props.onSuccess && this.refs.frame.contentWindow) {
            this.props.onSuccess(this, deproxyURL(this.refs.frame.contentWindow.location.href.replace(window.location.origin, '')), this._onCancel);
        }

        this._addUnloadHandler();
    }

    _onError = () => {
        if (this._unloadTimeoutID) {
            this._onAfterUnload();
        }

        this.setState({ pending: false });

        if (this.props.onFail && this.refs.frame.contentWindow) {
            this.props.onFail(this, deproxyURL(this.refs.frame.contentWindow.location.href.replace(window.location.origin, '')), this._onCancel);
        }

        this._addUnloadHandler();
    }


    _onBackClick = () => {
        this._onNavigate(this.state.history, this.state.currentIndex - 1);
    }

    _onForwardClick = () => {
        this._onNavigate(this.state.history, this.state.currentIndex + 1);
    }

    _onURLChange = (sender, url) => {
        this.setState({ editingURL: url });
    }

    _onURLSubmit = (sender, url) => {
        if (url) {
            this._onNavigate(
                [
                    ...this.state.history.slice(0, this.state.currentIndex + 1),
                    !url.startsWith('http') ? `http://${url}` : url
                ],
                this.state.currentIndex + 1
            );
        }
        this.refs['go'].focus();
    }

    _onURLBlur = (sender, value, event) => {
        if (!isAncestorOrSelf(this.refs.go, event.relatedTarget)) {
            this.setState({ editingURL: this.state.history[this.state.currentIndex] });
        }
    }

    _onGoClick = () => {
        this._onURLSubmit(this, this.state.editingURL);
    }

    render() {
        return (
            <div className={`proxy-frame ${this.props.className}`}>
                {
                    this.props.navbar === true ?
                        <div className="navbar row" >
                            <div>
                                <button className="inline fa fa-chevron-left"
                                    onClick={this._onBackClick}
                                    disabled={this.state.currentIndex <= 0} />
                            </div>
                            <div>
                                <button className="inline fa fa-chevron-right"
                                    onClick={this._onForwardClick}
                                    disabled={this.state.currentIndex >= this.state.history.length - 1} />
                            </div>
                            <div className="main-col">
                                <TextInput value={this.state.editingURL}
                                    placeholder={{ id: 'market_watch_settings.website_address' }}
                                    onChange={this._onURLChange}
                                    onSubmit={this._onURLSubmit}
                                    onBlur={this._onURLBlur} />
                            </div>
                            <div className="go">
                                <button ref="go" onClick={this._onGoClick}
                                    disabled={!this.state.editingURL || this.state.history[this.state.currentIndex] === this.state.editingURL}>
                                    <FormattedResource resource={{ id: 'market_watch_settings.go' }} />
                                </button>
                            </div>
                        </div> :
                        this.props.navbar ?
                            <div className="navbar" >{this.props.navbar}</div> :
                            null
                }
                <div className="row">
                    {
                        this.props.sidebar ?
                            <div className="sidebar left">{this.props.sidebar}</div> :
                            null
                    }

                    <div className="main-col">
                        <iframe ref="frame"
                            src={proxyURL(this.state.history[this.state.currentIndex])} onLoad={this._onLoad} onError={this._onError}
                            frameBorder="0" scrolling={this.props.scrollable ? 'yes' : 'no'} />
                        {
                            this.state.pending ?
                                <Spinner className="overlay" /> :
                                this.props.overlay ?
                                    <div className="overlay">{this.props.overlay}</div> :
                                    null
                        }
                    </div>
                </div>
            </div>
        );
    }
}